module.exports = require('./helpers/bundle-url').getBundleURL('cGICz') + "6611.637658b1.jpg";